import React, { Component } from 'react'
import HOCVerifyIsAdmin from './HOC/HOCVerifyIsAdmin'
import HoCtToastContainer from './HOC/HoCtToastContainer'
import TableList from './CustomTool/TableList'
import { fetchInward, apiURL } from './API/API'
import { Grid, Box } from "@material-ui/core";
import Progress from './CustomTool/Progress'
import { get_YMD_from_SYS } from './SystemUtility/SystemUtility'
import CtDtpDOB from './CustomTool/CtDtpDOB'
import CtBtn from './CustomTool/CtBtn'

class StockRegister extends Component {

    state = {
        dataLoadStatus: false,
        columns: [
            { id: 'Action', name: 'Search', label: 'Action', width: '100px' },
            { id: 'SrNo', label: 'Sr. No.', align: 'center' },
            { id: 'ProductName', label: 'Product Name' },
            { id: 'OpeningStock', label: 'Opening Stock', align: 'right' },
            { id: 'InwardQty', label: 'Inward Qty', align: 'right' },
            { id: 'SalesQty', label: 'Sales Qty', align: 'right' },
            { id: 'ClosingStock', label: 'Closing Stock', align: 'right' },
        ],
        rows: [],
        rowsCount: 0,
        rowsPerPage: 10,
        actionList: [],
        searchData: {
            ProductName: ''
        },
        searchColumns: [],
        searchRows: [],
        searchOpen: false,
        searchRowsCount: 0,
        keyColumn: [],
        ARD: null,
        formData: {
            dtpFromDate: get_YMD_from_SYS(new Date()),
            dtpToDate: get_YMD_from_SYS(new Date())
        },
    }

    //#region Component
    componentWillMount() {
        this.props.validateIsAdmin(this.props.setActiveLink, this.navigateTo)
    }

    componentDidMount() {
        this.props.setActiveLink({ LinkSlug: "StockRegister" })
        this.setSearchColumns()
        this.listStockRegister()
    }
    //#endregion

    //#region Handle
    handleChangeRowsPerPage = (rowsPerPage) => {
        this.setState({ rowsPerPage })
    }

    handleOnSearchChange = (searchOpen) => {
        let searchRows = []
        if (searchOpen === true && this.state.rows.length > 0) {
            this.state.rows.map((row) => {
                if (
                    searchOpen === true &&
                    ((this.state.searchData.ProductName.length === 0 || row['ProductName'].toString().includes(this.state.searchData.ProductName)))
                ) {
                    searchRows.push(row)
                }
            })
            const searchRowsCount = searchRows.length
            this.setState({
                searchOpen,
                searchRows,
                searchRowsCount,
                counter: this.state.counter + 1,
            }, () => {
                // console.log('searchRows on end of Function', searchRows)
            })
        } else {
            this.setState({ searchOpen })
        }
    }

    handleOnSearchInputChange = (e) => {
        // console.log('handleOnSearchInputChange', [e.target.name], e.target.value, this.state.searchData);
        this.setState({
            searchData: { ...this.state.searchData, [e.target.name]: e.target.value }
        }, () => {
            this.handleOnSearchChange(this.state.searchOpen)
            // console.log(this.state.searchData)
        })
    }
    handleOnChangeTrim = (e) => {
        this.setState({
            formData: { ...this.state.formData, [e.target.name]: e.target.value.trim() }
        })
    }
    //#endregion

    //#region Function
    navigateTo = (link) => {
        this.props.history.push('/' + link)
    }

    setSearchColumns = () => {
        let searchColumns = []
        searchColumns.push(
            {
                cType: 'Lbl',
                label: 'Sr No.',
                width: '50',
            },
            {
                cType: 'CtTxt',
                id: 'ProductName',
                label: 'Product Name',
                value: this.state.searchData.ProductName,
                handleOnChange: this.handleOnSearchInputChange,
                width: '250',
                maxLength: '100'
            },
            {
                cType: 'Lbl',
                label: 'Opening Stock',
                width: '50',
            },
            {
                cType: 'Lbl',
                label: 'Inward Qty',
                width: '50',
            },
            {
                cType: 'Lbl',
                label: 'Sales Qty',
                width: '50',
            },
            {
                cType: 'Lbl',
                label: 'Closing Stock',
                width: '50',
            }
        )
        this.setState({ searchColumns })
    }

    listStockRegister = (generatePDF = false) => {
        this.setState({ dataLoadStatus: false }, () => {
            let FromDate = this.state.formData.dtpFromDate,
                ToDate = this.state.formData.dtpToDate,
                GeneratePDF = generatePDF
            const reqData = {
                Op: 'StockRegister',
                FromDate,
                ToDate,
                GeneratePDF
            }
            fetchInward(reqData)
                .then(res => {
                    const rows = res.data.StockRegister
                    const rowsCount = rows.length
                    this.setState({ rows, rowsCount, dataLoadStatus: true })
                })
                .catch(error => {
                    this.props.toastMsg('error', 'Unkonwn Error occured in listStockRegister. ' + error)
                })
        })
    }

    openStockRegisterPDF = () => {
        let reqData = [
            { name: 'Op', value: 'StockRegister' },
            { name: 'FromDate', value: this.state.formData.dtpFromDate },
            { name: 'ToDate', value: this.state.formData.dtpToDate },
        ]
        var form = document.createElement("form");
        form.setAttribute("method", "post");
        form.setAttribute("action", apiURL + 'print.php');
        form.setAttribute("target", "view");

        reqData.forEach((data) => {
            console.log("data", data);
            var hiddenField = document.createElement("input");
            hiddenField.setAttribute("type", "hidden");
            hiddenField.setAttribute("name", data.name);
            hiddenField.setAttribute("value", data.value);
            form.appendChild(hiddenField);
            document.body.appendChild(form);
        })
        window.open('', 'view');
        form.submit();
    }
    //#endregion

    render() {
        let rows = (this.state.searchOpen) ? (this.state.searchRows) : (this.state.rows)
        let rowsCount = (this.state.searchOpen) ? (this.state.searchRowsCount) : (this.state.rowsCount)
        return (
            <div>
                <Progress color='secondary' display={this.state.dataLoadStatus !== true} />
                <Grid container direction="row" justify="center" alignItems="center">
                    <Grid item className="pageTitle">
                        <label htmlFor="Title" className='pageTitleText'>Stock Register</label>
                    </Grid>
                </Grid>
                <form>
                    <br />
                    <Grid container direction="row" justify="left" alignItems="center" spacing={5}>
                        <Grid item>
                            <CtDtpDOB
                                id='dtpFromDate'
                                label='From Date'
                                width='150'
                                handleOnChange={this.handleOnChangeTrim}
                                defaultValue={this.state.formData.dtpFromDate}
                                value={this.state.formData.dtpFromDate}
                                onKeyDown={this.props.onKeyDown}
                            // disabled={this.state.disabledProfileData.DOBDS}
                            />
                        </Grid>
                        <Grid item>
                            <CtDtpDOB
                                id='dtpToDate'
                                label='To Date'
                                width='150'
                                handleOnChange={this.handleOnChangeTrim}
                                defaultValue={this.state.formData.dtpToDate}
                                value={this.state.formData.dtpToDate}
                                onKeyDown={this.props.onKeyDown}
                            // disabled={this.state.disabledProfileData.DOBDS}
                            />
                        </Grid>
                        <Grid item>
                            <CtBtn label='List' width={80} onClick={() => { this.listStockRegister() }} />
                        </Grid>
                        <Grid item>
                            <CtBtn label='PDF' width={80} onClick={() => { this.openStockRegisterPDF() }} />
                        </Grid>
                    </Grid>
                </form>
                <br />
                <TableList
                    columns={this.state.columns}
                    rows={rows}
                    rowsCount={rowsCount}
                    rowsPerPage={this.state.rowsPerPage}
                    handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                    // onActionClick={this.handleARDonActionClick}
                    actionList={this.state.actionList}
                    keyColumn={this.state.keyColumn}
                    handleOnSearchChange={this.handleOnSearchChange}
                    searchColumns={this.state.searchColumns}
                    searchData={this.state.searchData}
                    provideSearch={true}
                // onNewEntryClick={this.onNewEntryClick}
                // toolTipNewEntry='New Stock Entry'
                />
                <Grid item>
                    <Box display={{ xs: 'none' }} style={{ textAlign: 'right' }}>
                        {this.state.ARD}
                    </Box>
                </Grid>
            </div>
        )
    }

}
export default HOCVerifyIsAdmin(HoCtToastContainer(StockRegister))